import React from "react";
import MetaTags from "components/MetaTags";
import { ContainerWithOffset } from "components/Elements/Container";
import AnimatedBox from "components/Elements/AnimatedBox";
import ButtonTicker from "components/Elements/ButtonTicker";
import parse from "html-react-parser";
import API from "strapi/api";
import ImageGliph from "components/Elements/ImageGlliph";

export default function Careers(props) {
  const generateDelay = () => {
    return Math.floor(Math.random() * 6) + 1;
  };

  return (
    <>
      <MetaTags
        title={
          props.content.meta_info && props.content.meta_info.meta_title
            ? props.content.meta_info.meta_title
            : "CAREERS"
        }
        description={
          props.content.meta_info && props.content.meta_info.meta_description
            ? props.content.meta_info.meta_description
            : "Careers - ZANAD | An Independent Animation Production Studio"
        }
        image={
          props.content.meta_info && props.content.meta_info.og_image
            ? API.getNextImage(props.content.meta_info.og_image, "large")
            : "/public/og-image.jpg"
        }
      />
      <main>
        <h1 className="offscreen-title">Careers</h1>
        <ContainerWithOffset>
          <p className="mt-8 mb-6 uppercase fluid-type">
            <span className="flex flex-row justify-start">
              <span className="optical-align letter-i">
                <AnimatedBox num={3.5}>If </AnimatedBox>
                <AnimatedBox num={1}>you </AnimatedBox>
                <AnimatedBox num={6}>like</AnimatedBox>
                <AnimatedBox num={2.5}>
                  <ImageGliph src="MARGIN_MAGIC" />
                </AnimatedBox>
                <AnimatedBox num={5}>to</AnimatedBox>
              </span>
            </span>
            <span className="flex flex-row justify-end">
              <span>
                <AnimatedBox num={2}>move </AnimatedBox>
                <AnimatedBox num={5}>it </AnimatedBox>
                <AnimatedBox num={1.5}>move </AnimatedBox>
                <AnimatedBox num={4.5}>it</AnimatedBox>
              </span>
            </span>
            <span className="flex flex-row justify-start">
              <span className="optical-align letter-z">
                <AnimatedBox num={3.5}>Zanad&apos;s </AnimatedBox>
                <AnimatedBox num={2.5}>the</AnimatedBox>
                <AnimatedBox num={4.5}>
                  <ImageGliph src="MARGIN_WIZARD" />
                </AnimatedBox>
                <AnimatedBox num={1}>place </AnimatedBox>
                <AnimatedBox num={3}>to </AnimatedBox>
                <AnimatedBox num={5.5}>go.</AnimatedBox>
              </span>
            </span>
          </p>
          <div className="mb-24 leading-tight text-20 768:text-30 1024:text-40 1280:text-48 indent-10 768:indent-20 1024:indent-36 1280:indent-48 content-with-glyphs">
            {parse(props.content.content)}
          </div>

          {props.content.job.length ? (
            props.content.job.map((job, i) => {
              return (
                <div
                  className="grid grid-cols-1 gap-4 mb-24 640:gap-12 768:gap-10 1024:gap-16 991:grid-cols-2"
                  key={i}
                >
                  <h2 className="uppercase fluid-type">
                    {job.level && (
                      <AnimatedBox num={generateDelay()}>
                        <span className="block">{job.level}</span>
                      </AnimatedBox>
                    )}

                    <AnimatedBox num={generateDelay()}>
                      <span className="block">{job.position}</span>
                    </AnimatedBox>
                  </h2>
                  <div>
                    <div className="max-w-screen-md mb-8 leading-tight text-16 768:text-18 1280:text-22">
                      <p>{job.description}</p>
                    </div>
                    <div className="grid gap-4 mb-4 640:gap-10 1024:gap-6 640:grid-cols-2">
                      {job.responsibilities && (
                        <div className="mb-4 leading-tight text-content text-16 768:text-18 1280:text-22 640:mb-0 content-with-glyphs">
                          <p>RESPONSIBILITIES</p>

                          {parse(job.responsibilities)}
                        </div>
                      )}

                      {job.requirements && (
                        <div className="leading-tight text-content text-16 768:text-18 1280:text-22">
                          <p>REQUIREMENTS</p>

                          {parse(job.requirements)}
                        </div>
                      )}
                    </div>

                    <ButtonTicker
                      title="Apply now"
                      url={
                        job.email_apply
                          ? "mailto:" + job.application
                          : job.application
                      }
                      external={true}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-careers">
              <p className="mt-8 mb-6 uppercase fluid-type">
                <span className="flex flex-row justify-start">
                  <span className="optical-align letter-i">
                    <AnimatedBox num={3.5}>one </AnimatedBox>
                    <AnimatedBox num={1}>more </AnimatedBox>
                    <AnimatedBox num={6}>person </AnimatedBox>
                    <div className="inline-flex 768:-ml-4">
                      <AnimatedBox num={2.5}>
                        <ImageGliph src="MARGIN_SKULL" />
                      </AnimatedBox>
                    </div>
                    <AnimatedBox num={5}>and </AnimatedBox>
                    <AnimatedBox num={3}>we’ll </AnimatedBox>
                  </span>
                </span>
                <span className="flex flex-row justify-end text-right">
                  <span className="optical-align letter-z">
                    <AnimatedBox num={3.5}>all </AnimatedBox>
                    <AnimatedBox num={2.5}>get </AnimatedBox>
                    <AnimatedBox num={1}>socially </AnimatedBox>
                    <AnimatedBox num={3}>anxious</AnimatedBox>
                    <AnimatedBox num={2.5}>
                      <ImageGliph src="MARGIN_GLOBE" />
                    </AnimatedBox>
                  </span>
                </span>
              </p>

              <p className="mb-24 leading-tight text-20 768:text-30 1024:text-40 1280:text-48 indent-10 768:indent-20 1024:indent-36 1280:indent-48 content-with-glyphs">
                Even if we’re not hiring right now for the position you’re
                looking for, we’d still love to see your work. Email us at{" "}
                <a
                  className="transition-colors border-b-2 border-black hover:border-white"
                  href="mailto:work@zanad.tv"
                >
                  work@zanad.tv
                </a>
              </p>
            </div>
          )}
        </ContainerWithOffset>
      </main>
    </>
  );
}

export async function getStaticProps(ctx) {
  const content = await API.getSingleType("career");

  return {
    props: {
      content: content,
    },
    revalidate: 10,
  };
}
